export default __webpack_public_path__ + "static/media/303.8771f08f.png";